import React, { Component, Fragment } from "react";
import { Menu, Icon, Checkbox } from "semantic-ui-react";
import { connect } from "react-redux";
import * as actions from "../../actions/users/getUserActions";
import API from "../../Constants/API";
import * as usersServices from "../../services/users/index";
import {
  createNotification,
  NOTIFICATION_TYPE_SUCCESS,
} from "react-redux-notify";

import { bindActionCreators } from "redux";
import svg_icon_path from "../../static/media/SVGSpriteIcon.svg"
var userDetails = atob(localStorage.getItem("userDetails"));
if (userDetails) {
    try {
        userDetails = JSON.parse(userDetails);
    }
    catch (error) {
        console.error('Invalid JSON input:', error.message);
    }
}

const LOGIN_USER_ID = userDetails ? userDetails.UserContext.userId : 1;
const FirmEnableSSO =
  userDetails && userDetails.UserContext.FirmEnableSSO
    ? userDetails.UserContext.FirmEnableSSO
    : "N";
class UserGridActions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: null,
      textLabel: "Disable Users",
      isDisabled: false,
    };
  }

    activeInactivetoggle(e) {       
        const accountStatus = this.state.isChecked ? 'Y' : 'N';
        var activeInactiveDataobj = {
            useriddetail: this.props.selectedUsersIds.join(),
            account_disabled: accountStatus,
            loggedUserId: LOGIN_USER_ID,
        };
        if (
            this.props.lookup.LicenseCount >=
            this.props.lookup.ActiveUsersCount +
            this.props.selectedUsersIds.length ||
            activeInactiveDataobj.account_disabled == 'Y'
        ) {
            this.props.actions
                .userAccountStatusUpdate(activeInactiveDataobj, this.props.allUsers)
                .then(() => {
                    const userStatusNotification = {
                        message: 'User status changed successfully',
                        type: NOTIFICATION_TYPE_SUCCESS,
                        duration: 5000,
                        canDismiss: true,
                        showCloseAllBtn: true,
                    };
                    this.props.createNotification(userStatusNotification);
                });
        }
    }

  handleBulkEditClick = () => {
    this.props.toggleBulkEditForm();
  };

  moveToTop = () => {
    let allUsers = this.props.allUsers;
    let selectedUsersIds = this.props.selectedUsersIds;
    let selected = allUsers.filter((el) =>
      selectedUsersIds.includes(el.user_id)
    );
    let notSelected = allUsers.filter(
      (el) => !selectedUsersIds.includes(el.user_id)
    );
    let finalList = [...selected, ...notSelected];
    //console.log("SelectedUsers", finalList);
    this.props.actions.sortBySelectedUsers(true, finalList);
  };

  async notifyPasswordChange() {
    let useriddetail = this.props.selectedUsersIds.join();
    var notifyPasswordDataobj = {
      useriddetail: this.props.selectedUsersIds.join(),
      loggedUserId: LOGIN_USER_ID,
    };
    const request = await usersServices.req.updateNotifyPassword(
      API.notifyPasswordChange,
      notifyPasswordDataobj
    );
    if (request) {
      let allUsers = this.props.allUsers;
      let updatedUsers = allUsers.map((user) => {
        if (
          notifyPasswordDataobj.useriddetail.includes(user.user_id.toString())
        ) {
          user.selected = false;
        }
        return user;
      });

      this.props.actions.clearSelectedUsers(updatedUsers);
      const notifyPasswordNotification = {
        message: "Must Change Password Successful...",
        type: NOTIFICATION_TYPE_SUCCESS,
        duration: 5000,
        canDismiss: true,
        showCloseAllBtn: true,
      };
      this.props.createNotification(notifyPasswordNotification);
      // this.props.actions.notifyUser("Notify Password Change Successful..");
    }
  }

  async resendResetPasswordChange() {
    //  let useriddetail = this.props.selectedUsersIds.join();
    var resendResetPasswordDataobj = {
      useriddetail: this.props.selectedUsersIds.join(),
      loggedUserId: LOGIN_USER_ID,
      FirmEnableSSO: FirmEnableSSO,
    };
    const request = await usersServices.req.updateNotifyPassword(
      API.resendResetPasswordChange,
      resendResetPasswordDataobj
    );
    if (request) {
      let allUsers = this.props.allUsers;
      let updatedUsers = allUsers.map((user) => {
        if (
          resendResetPasswordDataobj.useriddetail.includes(
            user.user_id.toString()
          )
        ) {
          user.selected = false;
        }
        return user;
      });

      this.props.actions.clearSelectedUsers(updatedUsers);
      const notifyPasswordNotification = {
        message: "Welcome Email Resent Successfully...",
        type: NOTIFICATION_TYPE_SUCCESS,
        duration: 5000,
        canDismiss: true,
        showCloseAllBtn: true,
      };
      this.props.createNotification(notifyPasswordNotification);
      // this.props.actions.notifyUser("Notify Password Change Successful..");
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (props.selectedUsersStatus.every((el) => el === "Inactive")) {
      state.isChecked = false;
      state.textLabel = "Enable Users";
      state.isDisabled = false;
    } else if (props.selectedUsersStatus.every((el) => el === "Active")) {
      state.isChecked = true;
      state.textLabel = "Disable Users";
      state.isDisabled = false;
    } else {
      state.isDisabled = true;
      state.textLabel = state.textLabel;
    }

    return state;
  }

  render() {
    // const { checked } = this.state;

    return (
      <Fragment>
        <Menu text icon className="linear-gradient">
          <Menu.Item
            name="Bulk Edit"
            onClick={this.handleBulkEditClick.bind(this)}
          >
            <svg className={`svg_icon xcm-icon-edit-bulk size-24 mr-4`}>
                            <title> Bulk Edit </title>
                            <use xlinkHref={`${svg_icon_path}#xcm-icon-edit-bulk`}> </use>
                        </svg>
            Bulk Edit
          </Menu.Item>
          <Menu.Item>
            <Checkbox
              className="hidden-checkbox"
              label={this.state.textLabel}
              disabled={this.state.isDisabled}
              onChange={this.activeInactivetoggle.bind(this)}
              checked={this.state.isChecked}
            />
          </Menu.Item>
          {FirmEnableSSO == "N" ? (
            <Menu.Item
              name="Must Change Password"
              onClick={this.notifyPasswordChange.bind(this)}
            >
              <svg className={`svg_icon xcm-icon-change-password size-24 mr-4`}>
                                <title> Must
              Change Password </title>
                                <use xlinkHref={`${svg_icon_path}#xcm-icon-change-password`}> </use>
                            </svg> Must
              Change Password{" "}
            </Menu.Item>
          ) : (
            ""
          )}

      {FirmEnableSSO == "N" ? (
          <Menu.Item
            name=""
            onClick={this.resendResetPasswordChange.bind(this)}
            className="border-right-0"
          >
            <svg className={`svg_icon xcm-icon-email-resend size-24 mr-4`}>
                                <title> Resend
            Welcome Email </title>
                                <use xlinkHref={`${svg_icon_path}#xcm-icon-email-resend`}> </use>
                            </svg> Resend
            Welcome Email
          </Menu.Item>
           ) : (
            ""
          )}
          <Menu.Menu position="right">
            <Menu.Item>
              <em>{this.props.selectedUsersIds.length} Selected{" "}</em>
              <svg className={`svg_icon xcm-icon-sort-up size-24 mr-4`} onClick={this.moveToTop.bind(this)}>
                                <title> Selected </title>
                                <use xlinkHref={`${svg_icon_path}#xcm-icon-sort-up`}> </use>
                            </svg>
            </Menu.Item>
          </Menu.Menu>
        </Menu>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  //console.log("checking mapStateToPropsBulkedit", state);
  return {
    allUsers: state.userReducer.allUsers,
    selectedUsersIds: state.userReducer.selectedUsers.selectedUsersIds,
      selectedUsersStatus: state.userReducer.selectedUsers.selectedUsersStatus,
      lookup: state.userReducer.lookupData,
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch),
  createNotification: (config) => {
    dispatch(createNotification(config));
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(UserGridActions);
